<template>
  <div class="sr-wrapper">
    <h1 class="text-center sr-title">Shape Recognition</h1>

    <!-- Category selector -->
    <div class="cat-bar text-center">
      <button
        v-for="c in categories"
        :key="c.id"
        class="cat-btn"
        :class="{ 'cat-btn--active': category === c.id }"
        @click="setCategory(c.id)"
      >
        {{ c.label }}
      </button>
    </div>

    <p class="cat-desc text-center">{{ currentDesc }}</p>

    <hr class="sr-hr" />

    <app-question
      :key="questionKey"
      :category="category"
    ></app-question>
  </div>
</template>

<script>
import Question from "./ShapeRecognitionQuestion.vue";

const CATEGORIES = [
  { id: "all",      label: "All",            desc: "Random mix of all question types." },
  { id: "identify", label: "Identify",        desc: "Name the shape shown." },
  { id: "props",    label: "Sides & Angles",  desc: "How many sides, vertices or angles does the shape have?" },
  { id: "area",     label: "Area Formula",    desc: "Which formula gives the area of the shape shown?" },
];

export default {
  components: { appQuestion: Question },
  data() {
    return {
      categories: CATEGORIES,
      category:   "all",
      questionKey: 0,
    };
  },
  computed: {
    currentDesc() {
      return CATEGORIES.find(c => c.id === this.category)?.desc ?? "";
    },
  },
  methods: {
    setCategory(id) {
      this.category = id;
      this.questionKey++;
    },
  },
};
</script>

<style scoped>
.sr-wrapper {
  max-width: 620px;
  margin: 0 auto;
  padding: 24px 16px 60px;
  min-height: 65vh;
}
.sr-title {
  color: rgb(3, 53, 48);
  margin-bottom: 16px;
}
.cat-bar {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.cat-btn {
  border-radius: 20px;
  padding: 5px 18px;
  font-size: 14px;
  cursor: pointer;
  background: transparent;
  color: rgb(3, 53, 48);
  border: 1.5px solid rgb(3, 53, 48);
  transition: all 0.18s;
}
.cat-btn:hover { background: rgb(169, 247, 234); }
.cat-btn--active {
  background: rgb(3, 53, 48);
  color: white;
  border-color: rgb(3, 53, 48);
}
.cat-desc {
  font-size: 14px;
  color: #555;
  min-height: 20px;
  margin-bottom: 6px;
}
.sr-hr {
  border-color: rgba(3, 53, 48, 0.2);
  margin-bottom: 20px;
}
</style>
